module.exports = __webpack_public_path__ + "img/camera.0751f37a.svg";